import axios from "axios";
import { baseUrl } from "../util";

// Flow 46 Totals
export const getBeyondProductLifeCycle46Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/beyond-product-life-cycle-46-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching beyond product life cycle 46 totals:", error);
      setTotals(null);
    });
};

// Flow 46 - Beyond product life cycle
export const getAllFlow46LCA = ({
  productId,
  setObjects = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/flow-46-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching flow 46:", error);
      setObjects([]);
    });
};

export const addFlow46LCA = ({
  productId,
  name_part_in_fu,
  what_material_prevent_purchase,
  quantity_per_fu,
  country_of_origin,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/flow-46-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_part_in_fu: name_part_in_fu || null,
      what_material_prevent_purchase: what_material_prevent_purchase || null,
      quantity_per_fu: quantity_per_fu || 0,
      country_of_origin: country_of_origin || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 46 item added successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding flow 46:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to add flow 46 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const updateFlow46LCA = ({
  productId,
  rowId,
  name_part_in_fu,
  what_material_prevent_purchase,
  quantity_per_fu,
  country_of_origin,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/flow-46-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_part_in_fu: name_part_in_fu || null,
      what_material_prevent_purchase: what_material_prevent_purchase || null,
      quantity_per_fu: quantity_per_fu || 0,
      country_of_origin: country_of_origin || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updatedObjects = objects.map((obj) =>
          obj.id === rowId ? { ...obj, ...response.data.data } : obj
        );
        setObjects(updatedObjects);
      }
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 46 item updated successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating flow 46:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update flow 46 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const deleteFlow46LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/flow-46-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      window.swal({
        title: "Success!",
        text: "Flow 46 item deleted successfully",
        icon: "success",
        button: "OK",
      });
    })
    .catch(function (error) {
      console.error("Error deleting flow 46:", error);
      window.swal({
        title: "Error!",
        text: error.response?.data?.message || "Failed to delete flow 46 item",
        icon: "error",
        button: "OK",
      });
    });
};

